<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th :colspan="columnLength" style="text-align: center">测评内容</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(judgeName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.judgeName)">{{ data.item.judgeName }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(judgeName)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">面试评分</div>
      </template>
      <template v-slot:foot(score)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'score') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "interviewReplyDetail",
  data() {
    return {
      fields: [
        {key: 'judgeName', label: '评估人', width: '120px'},
        {key: 'score', label: '得分', width: '120px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    this.items.forEach(item => {
      for (let i = 1; i <= 9; i++) {
        const key = `item${i}`
        item[key] = item[key] ? item[key].split(',')[1] : ''
      }
    })
    let columns = JSON.parse(this.$route.query.columns).map(item => {
      return {
        key: item.prop,
        label: item.label,
        width: '120px'
      }
    })
    this.columnLength = columns.length

    this.fields = [
      {key: 'judgeName', label: '评估人', width: '120px'},
        ...columns,
      {key: 'score', label: '得分', width: '120px'},
    ]
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total;
      }, 0).div(this.items.length).toFixed(0, Decimal.ROUND_HALF_UP);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
